const isSupportPopover = 'popover' in HTMLElement.prototype

if (!isSupportPopover) {
	import('@oddbird/popover-polyfill/fn').then(({ apply }) => {
		apply()
	})
}

if (!('anchorName' in document.documentElement.style)) {
	// @ts-ignore
	import('https://unpkg.com/@oddbird/css-anchor-positioning')
}

if (!('at' in Array.prototype)) {
	// @ts-ignore
	Array.prototype.at = function (this: Array, index) {
		if (index < 0) {
			index = this.length + index
		}

		return this[index]
	}
}

if (!('at' in Array.prototype)) {
	// @ts-ignore
	Array.prototype.at = function (this: Array, index) {
		if (index < 0) {
			index = this.length + index
		}

		return this[index]
	}
}

if (!('groupBy' in Object)) {
	// @ts-ignore
	Object.groupBy = <K extends PropertyKey, T>(
		items: Iterable<T>,
		getKey: (item: T, index: number) => K
	) =>
		Array.from(items).reduce<Partial<Record<K, T[]>>>((result, item, index) => {
			const key = getKey(item, index)
			result[key] ??= []
			result[key].push(item)

			return result
		}, {})
}

if (!('groupBy' in Map)) {
	// @ts-ignore
	Map.groupBy = <K, T>(
		items: Iterable<T>,
		getKey: (item: T, index: number) => K
	) =>
		Array.from(items).reduce((result, item, index) => {
			const key = getKey(item, index)

			if (!result.has(key)) {
				result.set(key, [])
			}

			result.get(key)!.push(item)

			return result
		}, new Map<K, T[]>())
}
